import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getPalette } from 'owa-theme';
import { mergeStyles } from '@uifabric/merge-styles';

/**
 * This util specifies the color to be applied to the rich location text
 * calPrimary of colorScheme is applied if colorScheme is present else themePrimary.
 * @param colorScheme colorScheme to be applied
 */
export default function getLocationTextStyle(colorScheme?: ColorScheme) {
    const textColor =
        (colorScheme &&
            colorScheme.accessibleText &&
            colorScheme.accessibleText.msColorWhiteBackground) ||
        getPalette().themePrimary;

    const hoverTextColor = colorScheme ? colorScheme.calDarker : getPalette().themeDarker;

    return mergeStyles({
        color: textColor,
        cursor: 'pointer',
        selectors: {
            '&:hover': {
                color: hoverTextColor,
            },
            '&:focus': {
                color: hoverTextColor,
            },
        },
    });
}
